<template>
    <div class="classify-detail-wrap">
        <div class="top-box">
            <div class="header-message">
                <div class="header-title" @mousemove="moveOnTitle" @mouseout="outOnTitle">
                    <span class="" v-show="!isTilteEditing">{{ data.classify }}</span>
                    <span v-if="isTilteEditing">
                        <input :placeholder="data.classify" v-model="titleValue" @keypress="keyPressHandler" @blur="emitEditEvent" ref="titleInput" />
                    </span>
                    <a class="title-edit-btn" @click="editTitle" v-show="!isTilteEditing && showIcon"></a>
                </div>
                <div class="message-content">
                    <span>{{ $t("zhiji.common.status") + "：" + labels[data.status] }}</span>
                    <span>{{ $t("zhiji.common.createTime") + "：" + data.updateTime }}</span>
                    <span>{{ $t("zhiji.common.creator") + "：" + data.creator }}</span>
                </div>
            </div>
            <div class="sensitive-word">
                {{ $t("zhiji.sensitiveWord.sensitiveWord") }}
                <em>({{ sensitiveTotal }})</em>
            </div>
            <div class="edit-lang">
                <LangSelect :value="initLang" class="lang-select" @change="langChange"></LangSelect>
            </div>
            <SensitiveWordsEdit :words="data" />
        </div>
        <BottomOperateBar :data="data" />
    </div>
</template>

<script>
import BottomOperateBar from "./BottomOperateBar";
import SensitiveWordsEdit from "./SensitiveWordsEdit";
import LangSelect from "@/components/langSelect";

export default {
    name: "ClassifyDetail",
    props: ["data"],
    components: {
        BottomOperateBar,
        SensitiveWordsEdit,
        LangSelect
    },
    data() {
        return {
            titleValue: "",
            isTilteEditing: false,
            showIcon: true
        };
    },
    computed: {
        initLang() {
            return this.data.lang;
        },
        labels() {
            return {
                online: this.$t("zhiji.knowlege.alreadyOn"),
                offline: this.$t("zhiji.knowlege.alreadyOff"),
                draft: this.$t("zhiji.knowlege.draft")
            };
        },
        sensitiveTotal() {
            return this.getStorePorp("allSensitiveWords").length || 0;
        }
    },
    methods: {
        langChange(data) {
            this.$store.commit("zhiji/editUpdateSensitive", {
                type: "updateContent",
                lang: data
            });
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.sensitiveWords[propName];
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;

            isEnterKey && this.emitEditEvent();
        },
        emitEditEvent() {
            const newTitle = this.zhiji.strTrim(this.titleValue);
            const isChanged = newTitle != this.answerName;

            if (newTitle && isChanged) {
                this.titleValue = "";
                this.$store.commit("zhiji/editUpdateSensitive", {
                    type: "updateContent",
                    title: newTitle
                });
            }

            this.isTilteEditing = false;
        },
        editTitle() {
            this.isTilteEditing = true;
            this.$nextTick(() => {
                this.$refs.titleInput && this.$refs.titleInput.focus();
            });
        },
        moveOnTitle() {
            this.showIcon = true;
        },
        outOnTitle() {
            this.showIcon = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.classify-detail-wrap {
    flex: 1;
    background: #fff;
    border-width: 0 1px 1px 0;
    border-style: solid;
    border-color: #d8e4f0;
    display: flex;
    flex-direction: column;
    padding: 16px 0 0 0;
    box-sizing: border-box;
    .top-box {
        height: 100%;
        flex: 1;
        overflow-y: auto;
    }
    .header-message {
        padding-left: 24px;
        .header-title {
            margin-bottom: 12px;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            .title-edit-btn {
                display: inline-block;
                width: 18px;
                height: 18px;
                margin: 0 5px 0 10px;
                vertical-align: -3px;
                background: url($zhijiStaticImagePath+"class-spr.png") -76px 0;
                &:hover {
                    background-position: -76px -22px;
                }
            }
        }
        .message-content {
            color: #9b9ba3;
            margin-bottom: 16px;
            font-size: 12px;

            span {
                min-width: 200px;
                display: inline-block;
                margin-right: 10px;
            }
            :first-child {
                min-width: 80px;
            }
        }
    }
    .sensitive-word {
        padding-left: 24px;
        margin-bottom: 4px;
        em {
            font-size: 12px;
            color: #9b9ba3;
        }
    }
    .edit-lang {
        padding-left: 24px;
    }
}
</style>
